export class TagService {
  normalizeTagName(name: string) {
    name = name.trim();
    name = name.replace(/[^a-zA-Z0-9\s.\-()_]/g, '');
    if (name.length > 100) {
      name = name.substring(0, 100);
    }
    return name;
  }

  isValidTagName(name: string) {
    return name && this.normalizeTagName(name).length === name.length;
  }
}

angular.module('flowingly.runner.services').service('tagService', TagService);

export type TagServiceType = InstanceType<typeof TagService>;
